module.exports = "<div class=\"entry-header\">{{title}}<span class=\"border\"></span></div>\r\n"